import { FC, useState } from 'react';
import ReviewModal from '../ReviewModal';
import useIsMobile from 'src/hooks/useIsMobile';

const Reviews: FC = () => {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (isMobile) {
      window.open('https://www.sprinter-rentals.com/reviews', '_blank', 'noopener,noreferrer');
    } else setOpen(true);
  };

  return (
    <>
      <div className='filter-reviews' onClick={handleOpen}>
        <img src={require('src/common/img/reviews.jpg')} width='230px' alt='reviews' />
      </div>
      <ReviewModal open={open} handleClose={() => setOpen(false)} />
    </>
  );
};
export default Reviews;
